export default __webpack_public_path__ + "static/media/qwiklabs2.5584d417.png";